import { render, staticRenderFns } from "./muokkaa-seurantajaksoa-erikoistuja.vue?vue&type=template&id=fde6fdde&scoped=true&"
import script from "./muokkaa-seurantajaksoa-erikoistuja.vue?vue&type=script&lang=ts&"
export * from "./muokkaa-seurantajaksoa-erikoistuja.vue?vue&type=script&lang=ts&"
import style0 from "./muokkaa-seurantajaksoa-erikoistuja.vue?vue&type=style&index=0&id=fde6fdde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde6fdde",
  null
  
)

export default component.exports